import Vue from 'vue'

export default {
	async load({
		commit,
		rootState
	}, params = Object()) {
		let res = await Vue.prototype.$http.get(rootState.apiUrl + '/covid-19/', params)
			// commit('setData', res.data)
	},
}